export class MonthSelectorResult {
    confirmed: boolean = false;
    monat: number;
    jahr: number;
}
